module.exports = __webpack_public_path__ + "img/1577015615.763d79de.jpg";